import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { setColor, setFont } from "../../../../assets/styles/styles";
import IntraverseLogoFull from "../../../landingPages/intraverseLandingPage/IntraverseHomeImages/IntraverseLogoFull.png";
import Button from "../../../../components/common/button/Button";
import Footer from "../../../../components/layout/footer/Footer";
import BackgroundContainer from "../../../../components/common/Backgrounds/BackgroundContainer";
import { ReactComponent as IntraverseMiniLogoIcon } from "../../../../assets/images/icons/Coloured_Icon.svg";
import UserIcon from "../../../../assets/images/icons/User.png";
import Typography from "../../../../components/common/text/Typography";
import { fetchVanityLinkByRoomId } from "../../../../api/VanityLinkController";

const InviteRedirect = ({ roomId }) => {
    const navigate = useNavigate();
    const [message, setMessage] = useState(null);

    const signInFlow = async () => {
        try {
            navigate("/login");
        } catch (error) {
            setMessage("An error occurred while signing in.");
            console.error("Error during sign-in flow:", error);
        }
    };

    const guestFlow = async () => {
        try {
            const getVanityLink = await fetchVanityLinkByRoomId(roomId);
            if (getVanityLink.status === 200) {
                const { vanityLink } = getVanityLink.data;
                if (vanityLink) {
                    navigate(`/${vanityLink}`);
                } else {
                    setMessage("No vanity link found for this room.");
                }
            }
        } catch (error) {
            setMessage("An error occurred while signing in as a guest.");
            console.error("Error during guest flow:", error);
        }
    };

    return (
        <BackgroundContainer loginBorder>
            <HeaderDiv>
                <LoginLogo src={IntraverseLogoFull} alt="Company Logo" />
            </HeaderDiv>
            <ContentContainer>
                <LoginTitle>enter intraverse</LoginTitle>
                <LoginSubtitle>Enter with your Intraverse account or play as a guest.</LoginSubtitle>
                <CardContainer>
                    <Card onClick={signInFlow}>
                        <StyledIntraverseMiniLogoIcon />
                        <CardTitle>sign in & play</CardTitle>
                        <CardSubTitle>Play with or create an Intraverse account.</CardSubTitle>
                    </Card>
                    <Card onClick={guestFlow}>
                        <StyledUserIcon src={UserIcon} alt="User Icon" />
                        <CardTitle>play as a guest</CardTitle>
                        <CardSubTitle>No account? No problem! Finish later.</CardSubTitle>
                    </Card>
                </CardContainer>
                <Footer />
            </ContentContainer>
        </BackgroundContainer>
    );
};

export default InviteRedirect;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    margin-top: -20px;
`;

const StyledIntraverseMiniLogoIcon = styled(IntraverseMiniLogoIcon)`
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
    @media (max-width: 768px) {
        width: 60px;
        height: 60px;
        margin-bottom: 10px;
    }
`;

const StyledUserIcon = styled.img`
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
    @media (max-width: 768px) {
        width: 60px;
        height: 60px;
        margin-bottom: 10px;
    }
`;

const ErrorMessage = styled.div`
    color: ${setColor.errorColor};
    margin-bottom: 3px;
`;

const LoginLogo = styled.img`
    display: flex;
    align-self: flex-start;
    width: 250px;
    height: auto;
    margin-bottom: 30px;
    margin-left: 10px;

    @media (max-width: 768px) {
        align-self: center;
        margin-top: 0px;
        margin-right: 0px;
        margin-left: 0px;
    }
`;
const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    margin-bottom: 40px;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 10px;

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        margin-left: 0px;
        margin-top: 10px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

const LoginTitle = styled.h3`
    color: ${setColor.accent4};
    text-align: center;
    font-family: ${setFont.barlowCondensed};
    font-size: 40px;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;

    @media (max-width: 960px) {
        font-size: 40px;
    }

    @media (min-width: 960px) and (max-width: 1440px) {
        font-size: 40px;
    }
`;

const LoginSubtitle = styled.p`
    color: ${setColor.circularProgress};
    text-align: center;
    font-family: ${setFont.barlow};
    font-size: ${(props) => (props.fontSize ? props.fontSize : "18px")};
    font-weight: 400;
    margin-top: 1.5rem;

    @media (max-width: 960px) {
        margin: 0rem;
    }
`;

const CardContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    justify-content: center;
    align-items: center;
    width: auto;
    height: auto;
    margin: 2rem 0rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        margin: 1.5rem;
    }
`;

const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 230px;
    height: 230px;
    background-color: #252333;
    margin: 0rem 2rem;
    font-size: 24px;
    font-weight: bold;
    color: white;
    gap: 10px;
    border-radius: 3px;
    padding: 20px 10px;
    text-align: center;

    &:hover {
        background-color: rgb(44, 41, 62);
        cursor: pointer;
    }
    @media (max-width: 768px) {
        width: 70%;
        margin-left: 0px;
        margin-bottom: 20px;
        padding: 25px 10px;
    }
`;

const CardTitle = styled.div`
    color: #fbfcff;
    font-size: 20px;
    font-family: "Barlow";
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2px;
    word-wrap: break-word;
`;

const CardSubTitle = styled.div`
    color: #9da0a7;
    font-size: 16px;
    font-family: "Barlow";
    font-weight: 400;
    word-wrap: break-word;
    text-align: center;
    margin-top: 15px;
`;
